/**
 * Config: Timings
 * -----------------------------------------------------------------------------
 * Global configuration for consistent values for timing durations.
 *
 */
export const values = {
  xs: 0.1,
  s: 0.2,
  m: 0.4,
  l: 0.6,
  xl: 1,
  xxl: 3,
}

export default {
  xs: values.xs * 1000,
  s: values.s * 1000,
  m: values.m * 1000,
  l: values.l * 1000,
  xl: values.xl * 1000,
  xxl: values.xxl * 1000,
}
